var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "7bd21faae21392e1f67759b0cb06c1f906054737"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["ecommerce-rms-rodi-es@rodi"] = {
  id: "7bd21faae21392e1f67759b0cb06c1f906054737"
};